/**
 * Public report verification service (no authentication required)
 */

import { API_ENDPOINTS } from '../config/api.config';
import { apiGet } from '../utils/apiClient';
import type { ReportVerificationApiResponse } from '../types/reportVerification.types';

class ReportVerificationService {
  async getCertificate(studyInstanceUid: string): Promise<ReportVerificationApiResponse> {
    // Public QR verification is not gated on patient SMS link expiry.
    const response = await apiGet<ReportVerificationApiResponse>(
      API_ENDPOINTS.REPORTS.PUBLIC_VERIFY_BY_STUDY_UID(studyInstanceUid),
      { requireAuth: false }
    );

    return response.data;
  }
}

export const reportVerificationService = new ReportVerificationService();
export default reportVerificationService;
